import { render, staticRenderFns } from "./StudentShortLayout.vue?vue&type=template&id=68d7f4a4&scoped=true"
import script from "./StudentShortLayout.vue?vue&type=script&lang=js"
export * from "./StudentShortLayout.vue?vue&type=script&lang=js"
import style0 from "./StudentShortLayout.vue?vue&type=style&index=0&id=68d7f4a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7f4a4",
  null
  
)

export default component.exports